<div class="p-dialog-header px-0">
  <span class="p-dialog-title">{{ title }}</span>
  <div class="p-dialog-header-icons" *ngIf="showCloseButton">
    <button type="button" class="p-dialog-header-icon p-link" (click)="closeDialog(null)">
      <span class="p-dialog-header-close-icon pi pi-times"></span>
    </button>
  </div>
</div>
<ng-container *ngIf="isHTML; else plainText">
  <div [innerHTML]="message"></div>
</ng-container>
<ng-template #plainText>
  <div>
    {{ message }}
  </div>
</ng-template>
<div class="flex justify-content-end mt-4">
  <div [class.flex-1]="thirdButtonText" *ngIf="showCancelButton">
    <p-button
      label="{{ secondaryButtonLabel | translate }}"
      (click)="closeDialog(0)"
      styleClass="p-button p-button-text p-button-secondary text-geometric-precision mr-2"
    ></p-button>
  </div>
  <button *ngIf="thirdButtonText" pButton [label]="thirdButtonText" (click)="closeDialog(2)" class="p-button-outlined mr-2"></button>
  <button *ngIf="showPrimaryButton" pButton [label]="primaryButtonLabel" (click)="closeDialog(1)" data-test="confirmBtn"></button>
</div>
